export default "__VITE_ASSET__24SQ3f9Q__"